import { motion } from "framer-motion";
import { HandHeart, HouseLine, UsersThree } from "@phosphor-icons/react";

const DARK_BG = "/images/why-bg.webp";

const pillars = [
  {
    icon: HandHeart,
    title: "Built for local",
    body: "Every order keeps money circulating between shops, staff and families across Strabane and the wider area.",
  },
  {
    icon: HouseLine,
    title: "Fair for shops",
    body: "Low set percentage. Helping local businesses keep more of their profits.",
  },
  {
    icon: UsersThree,
    title: "Run by people you know",
    body: "We live here. If something breaks, it's fixed by someone you might bump into at the shop.",
  },
];

export default function WhyMyLocal() {
  return (
    <section
      id="why"
      data-testid="why-my-local-section"
      className="relative bg-[#0A0A0A] text-white grain overflow-hidden"
      style={{
        backgroundImage: `url(${DARK_BG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-[#0A0A0A]/70" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="max-w-4xl">
          <p className="overline text-[#FF1F8B] mb-5">Why My Local</p>
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="font-display font-extrabold text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.95]"
            data-testid="why-headline"
          >
            Not a big corporation. <br />
            <span className="text-zinc-500">Just local people</span> building
            something <span className="gradient-text">for the town.</span>
          </motion.h2>
          <p className="mt-8 text-lg md:text-xl text-zinc-400 max-w-2xl leading-relaxed">
            The big apps take a cut and leave. We stay. Every pound ordered
            through My Local keeps shutters up, kitchens busy and drivers on
            the road, right here.
          </p>
        </div>

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {pillars.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`pillar-${i}`}
              className="bg-white/[0.04] border border-white/10 rounded-3xl p-8 md:p-10 backdrop-blur-sm hover:bg-white/[0.06] transition-colors"
            >
              <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-[#C026D3]/25 via-[#FF1F8B]/20 to-[#FF4422]/20 text-[#FF1F8B] mb-6">
                <p.icon size={22} weight="duotone" />
              </div>
              <h3 className="font-display font-extrabold text-2xl tracking-tight mb-3">
                {p.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
